(() => {
  const STORAGE_KEY = 'uniway_customer_compare_products';

  const emptyState = document.querySelector('.js-customer-product-compare-empty');
  const layout = document.querySelector('.js-customer-product-compare-layout');
  const productsWrap = document.querySelector('.js-customer-product-compare-products');
  const tableWrap = document.querySelector('.js-customer-product-compare-table');
  const fieldToggles = document.querySelectorAll('[data-compare-field-toggle]');

  if (!emptyState || !layout || !productsWrap || !tableWrap) return;

  const fields = [
    {
      key: 'availability',
      label: 'Availability',
      getValue: (product) => product.available ? 'In stock' : 'Out of stock',
    },
    {
      key: 'brand',
      label: 'Brand',
      getValue: (product) => product.brand || product.vendor || '-',
    },
    {
      key: 'processor',
      label: 'Processor',
      getValue: (product) => product.processor || '-',
    },
    {
      key: 'memory',
      label: 'Memory',
      getValue: (product) => product.memory || '-',
    },
    {
      key: 'storage',
      label: 'Storage',
      getValue: (product) => product.storage || '-',
    },
    {
      key: 'condition',
      label: 'Condition',
      getValue: (product) => product.condition || '-',
    },
    {
      key: 'operating_system',
      label: 'Operating System',
      getValue: (product) => product.operating_system || '-',
    },
    {
      key: 'description',
      label: 'Description',
      getValue: (product) => product.description || '-',
    },
  ];

  const getProducts = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  };

  const saveProducts = (products) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  };

  const getVisibleFields = () => {
    return Array.from(fieldToggles)
      .filter((toggle) => toggle.checked)
      .map((toggle) => toggle.dataset.compareFieldToggle);
  };

  const escapeHtml = (value) => {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const renderProducts = (products) => {
    productsWrap.style.setProperty('--compare-product-count', products.length);
    productsWrap.innerHTML = products.map((product) => {
      const comparePrice = product.compare_at_price
        ? `<span class="customer-product-compare-card__compare-price">${escapeHtml(product.compare_at_price)}</span>`
        : '';

      return `
        <article class="customer-product-compare-card" data-product-id="${escapeHtml(product.id)}">
          <button
            type="button"
            class="customer-product-compare-card__remove js-customer-product-compare-remove"
            data-product-id="${escapeHtml(product.id)}"
            aria-label="Remove product"
          >
            ×
          </button>

          <a href="${escapeHtml(product.url)}" class="customer-product-compare-card__media">
            <img src="${escapeHtml(product.image)}" alt="" loading="lazy">
          </a>

          <div class="customer-product-compare-card__info">
            ${comparePrice}
            <div class="customer-product-compare-card__price">${escapeHtml(product.price || '')}</div>
            <a href="${escapeHtml(product.url)}" class="customer-product-compare-card__title">
              ${escapeHtml(product.title)}
            </a>
          </div>

          <a href="${escapeHtml(product.url)}" class="button button--primary customer-product-compare-card__button">
            View product
          </a>
        </article>
      `;
    }).join('');
  };

const renderTable = (products) => {
  const visibleFields = getVisibleFields();

  const rows = fields
    .filter((field) => visibleFields.includes(field.key))
    .map((field) => {
      const values = products.map((product) => {
        const rawValue = field.getValue(product);
        const value = field.key === 'description' ? rawValue : escapeHtml(rawValue);

        if (field.key === 'description') {
          return `
            <div class="customer-product-compare-table__cell customer-product-compare-table__cell--description">
              <strong class="customer-product-compare-table__mobile-label">${field.label}</strong>

              <div class="customer-product-compare-description js-customer-product-compare-description">
                <div class="customer-product-compare-description__content rte">
                  ${value || '-'}
                </div>

                <button
                  type="button"
                  class="customer-product-compare-description__toggle js-customer-product-compare-description-toggle"
                >
                  See more
                </button>
              </div>
            </div>
          `;
        }

        return `
          <div class="customer-product-compare-table__cell">
            <strong class="customer-product-compare-table__mobile-label">${field.label}</strong>
            <span>${value}</span>
          </div>
        `;
      }).join('');

      return `
        <div class="customer-product-compare-table__row" data-compare-field="${field.key}">
          <div class="customer-product-compare-table__heading">${field.label}</div>
          ${values}
        </div>
      `;
    }).join('');

  tableWrap.style.setProperty('--compare-product-count', products.length);
  tableWrap.innerHTML = rows;
};

const render = () => {
  const products = getProducts();

  if (products.length < 2) {
    emptyState.hidden = false;
    layout.hidden = true;

    emptyState.style.display = '';
    layout.style.display = 'none';

    productsWrap.innerHTML = '';
    tableWrap.innerHTML = '';

    return;
  }

  emptyState.hidden = true;
  layout.hidden = false;

  emptyState.style.display = 'none';
  layout.style.display = '';

  renderProducts(products);
  renderTable(products);
};

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.js-customer-product-compare-remove');

    if (!removeButton) return;

    const id = Number(removeButton.dataset.productId);
    const products = getProducts().filter((product) => Number(product.id) !== id);

    saveProducts(products);
    render();
  });

  document.addEventListener('click', (event) => {
    const filterToggle = event.target.closest('.js-customer-compare-filter-toggle');

    if (!filterToggle) return;

    const filters = filterToggle.closest('.customer-product-compare__filters');

    if (!filters) return;

    filters.classList.toggle('is-open');
  });

  document.addEventListener('click', (event) => {
  const toggleButton = event.target.closest('.js-customer-product-compare-description-toggle');

  if (!toggleButton) return;

  const description = toggleButton.closest('.js-customer-product-compare-description');

  if (!description) return;

  description.classList.toggle('is-expanded');

  toggleButton.textContent = description.classList.contains('is-expanded')
    ? 'See less'
    : 'See more';
});

  fieldToggles.forEach((toggle) => {
    toggle.addEventListener('change', render);
  });

  render();
})();